import { render, staticRenderFns } from "./AssembleModal.vue?vue&type=template&id=345609f8&scoped=true"
import script from "./AssembleModal.vue?vue&type=script&lang=js"
export * from "./AssembleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345609f8",
  null
  
)

export default component.exports